import { useContext } from 'react';
import { Button } from 'components/UI/Button/Button';
import { EventTileGroup } from 'components/UI/EventTileGroup/EventTileGroup';
import { EventTile } from 'components/UI/EventTile/EventTile';
import { EventFiltersContext } from '../../Shared/EventFiltersProvider';

export const WhatsOnGenreEventsResults = () => {
  const { eventsData, isBusy, pageNum, setPageNum, setIsBusy } = useContext(EventFiltersContext);

  const loadMoreEventsButtonHandler = () => {
    setIsBusy(true);
    setPageNum((prevPageNum) => prevPageNum + 1);
  };

  const events = eventsData?.events;
  const eventsCount = events?.length;

  if (!eventsCount) {
    return null;
  }

  const eventsResultContent = (
    <div className="container">
      <EventTileGroup collapseOnMobile>
        {events?.map((event, index) => (
          <EventTile {...event} key={index} collapseOnMobile />
        ))}
      </EventTileGroup>

      {(pageNum < eventsData.totalPages || isBusy) && (
        <div className="fullwidth-container text-center">
          <Button
            onClick={loadMoreEventsButtonHandler}
            variant="primary"
            extendClass={`btn-small load-more-events btn-loading ${
              isBusy ? 'component-loading' : ''
            }`}
            disabled={isBusy}
          >
            <div className="loading-overlay btn-loading-overlay">
              <div className="loading">LOADING</div>
            </div>
            Load more events
          </Button>
        </div>
      )}
    </div>
  );

  return <section className="event-tiles-wrap event-results">{eventsResultContent}</section>;
};
